import moment from 'moment';
import FeedbackDetailsList from '../feedbackDetailsList/feedbackDetailsList';
import ExportToPdf from '../../../shared/components/ExportToPdf/ExportToPdf';
import './FeedbackDetails.scss';

const formatDate = value => (value ? moment(value).format('DD-MMM-YYYY') : '—');

const FeedbackDetails = props => {
  const { feedbackResponse, isLoading } = props;

  if (isLoading) {
    return null;
  }

  const isCompleted = feedbackResponse?.status === 'completed';
  const statusClass = isCompleted ? 'statusCompleted' : 'statusPending';

  return (
    <div id="FeedbackDetails">
      <div className="feedbackDetailsHeader">
        <div className="employeeInfo">Feedback For: {feedbackResponse?.employeeName}</div>
        <ExportToPdf
          fileName={`feedback-details-${feedbackResponse?.employeeName || 'response'}.pdf`}
          feedbackResponse={feedbackResponse}
        />
      </div>

      <div className="feedbackResponseDetails">
        <div className="feedbackMeta">
          <div className="metaRow">
            <span className="metaLabel">Requested from</span>
            <span className="metaValue">
              {feedbackResponse?.requestedName || '—'}
              {feedbackResponse?.requestedEmail ? ` (${feedbackResponse.requestedEmail})` : ''}
            </span>
          </div>
          <div className="metaRow">
            <span className="metaLabel">Template</span>
            <span className="metaValue">{feedbackResponse?.templateName || '—'}</span>
          </div>
          <div className="metaRow">
            <span className="metaLabel">Requested on</span>
            <span className="metaValue">{formatDate(feedbackResponse?.createdAt)}</span>
          </div>
          {isCompleted && (
            <div className="metaRow">
              <span className="metaLabel">Completed on</span>
              <span className="metaValue">{formatDate(feedbackResponse?.updatedAt)}</span>
            </div>
          )}
          <div className="metaRow">
            <span className="metaLabel">Status</span>
            <span className={`metaStatus ${statusClass}`}>{feedbackResponse?.status || '—'}</span>
          </div>
        </div>

        {feedbackResponse?.questionsFeedbackResponse?.map((question, index) => (
          <FeedbackDetailsList
            question={question}
            key={question.questionId || index}
            index={index + 1}
          />
        ))}
      </div>
    </div>
  );
};

export default FeedbackDetails;
